<template>
  <div>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Cover Photo</base-card-heading>
      </template>
      <template v-if="hasCover()">
        <img class="img-thumbnail" :src="getCoverPath()">
      </template>
      <template v-else>
        <p class="text-center">
          No cover photo has been uploaded yet.
        </p>
      </template>
      <template v-slot:footer>
        <div class="text-right">
          <button-upload :path="`investments/${investment._id}/media`" secondary @uploaded="coverUploaded">
            Upload Photo
          </button-upload>
        </div>
      </template>
    </base-card>

    <base-card>
      <template v-slot:header>
        <base-card-heading>Photo</base-card-heading>
      </template>
      <template v-if="hasPhoto()">
        <img class="img-thumbnail" :src="getPhotoPath()">
      </template>
      <template v-else>
        <p class="text-center">
          No photo has been uploaded yet.
        </p>
      </template>
      <template v-slot:footer>
        <div class="text-right">
          <button-upload :path="`investments/${investment._id}/media`" secondary @uploaded="photoUploaded">
            Upload Photo
          </button-upload>
        </div>
      </template>
    </base-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import ButtonUpload from './ButtonUpload.vue'

export default {
  name: 'InvestmentMedia',

  components: {
    ButtonUpload
  },

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity
    })
  },

  methods: {
    coverUploaded (cover) {
      this.updateInvestment({
        _id: this.investment._id,
        cover: cover._id
      })
        .then(() => {
          this.$emit('refresh')
          this.$flash.success('Cover successfully uploaded.')
        })
        .catch(err => this.$flash.failure(err))
    },

    photoUploaded (photo) {
      this.updateInvestment({
        _id: this.investment._id,
        photo: photo._id
      })
        .then(() => {
          this.$emit('refresh')
          this.$flash.success('Photo successfully uploaded.')
        })
        .catch(err => this.$flash.failure(err))
    },

    getCoverPath () {
      if (this.hasCover()) {
        return this.$document.path(this.investment.cover)
      }
    },

    getPhotoPath () {
      if (this.hasPhoto()) {
        return this.$document.path(this.investment.photo)
      }
    },

    hasCover () {
      return this.$_.isPlainObject(this.investment.cover)
    },

    hasPhoto () {
      return this.$_.isPlainObject(this.investment.photo)
    },

    ...mapActions({
      updateInvestment: 'core/investments/update'
    })
  }
}
</script>
